var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.videoUrl)?_c('a',{staticClass:"play-btn video-btn",attrs:{"data-toggle":"modal","data-src":_vm.videoUrl,"data-target":"#modal"},on:{"click":function($event){return _vm.playVideo()}}},[_c('img',{class:_vm.isWhite ? "white" : "",attrs:{"alt":_vm.imgPlayAlt}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27dc243d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/PlayButton.vue
// module id = 56
// module chunks = 0